import { Map } from 'immutable';
import { createSelector } from 'reselect';

export const relayControllerStatusSelector = state => state.entities.relayControllerStatuses;

export const getRelayControllerStatusToUnitMapping = createSelector(relayControllerStatusSelector, statuses => {
  if (typeof statuses === 'undefined') {
    return Map();
  }
  let myMap = Map();

  statuses.forEach(status => {
    const controllerId = status.get('relay_controller', 0);
    if (controllerId) {
      const unit_id = status.get('relay_controller', '0').toString();
      myMap = myMap.set(unit_id, status);
    }
  });
  return myMap;
});
